// extracted by mini-css-extract-plugin
export var divider = "_tz-0";
export var systemMessage = "_tz-1";